import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        // 错误页面
        {
            path: "/error",
            name: "error",
            meta: {requireAuth: false, title: "错误", permission_id: ""},
            component(resolve) {
                require([`@/page/error/index.vue`], resolve)
            }
        },
        {
            path: "/redirect/:type",
            name: "redirect",
            meta: {requireAuth: false, title: "跳转页", permission_id: ""},
            component(resolve) {
                require([`@/page/redirect/index.vue`], resolve)
            }
        },
        {
            path: '/polyPage',
            name: "polyPage",
            meta: {requireAuth: false, title: "网址聚合页", permission_id: ""},
            component(resolve) {
                require([`@/page/polyPage`], resolve)
            }
        },
        {
            path: '/ordering',
            name: "orderingSystem",
            meta: {requireAuth: false, title: "客户下单系统", permission_id: ""},
            component(resolve) {
                require([`@/page/orderingSystem`], resolve)
            }
        },
        //设备点检大屏
        {
            path: "/Integrated",
            name: "Integrated",
            meta: {
                requireAuth: false,
                title: "设备点检大屏",
                permission_id: "1341",
            },
            component(resolve) {
                require([`@/page/Integrated/index.vue`], resolve)
            },
        },
        //设备点检大屏
        {
            path: "/patrol-review",
            name: "patrolReview",
            meta: {
                requireAuth: false,
                title: "巡检表预览",
                permission_id: "1341",
            },
            component(resolve) {
                require([`@/page/patrolReview/index.vue`], resolve)
            },
        },
        //设备点检大屏
        {
            path: "/issueReceipt",
            name: "issueReceipt",
            // redirect: "/issueReceipt/start",
            meta: {requireAuth: false, title: "仓储管理系统", permission_id: "1341"},
            component(resolve) {
                require([`@/page/issueReceipt/index.vue`], resolve)
            },
            // children: [
            //     {
            //         path: "start",
            //         name: "start",
            //         meta: {requireAuth: false, title: "开始", permission_id: "1341"},
            //         component(resolve) {
            //             require([`@/page/issueReceipt/start.vue`], resolve)
            //         },
            //     },
            //     {
            //         path: "scan",
            //         name: "issueReceiptScan",
            //         meta: {requireAuth: false, title: "扫码", permission_id: "1341"},
            //         component(resolve) {
            //             require([`@/page/issueReceipt/scan.vue`], resolve)
            //         },
            //     },
            //     {
            //         path: "handle",
            //         name: "issueReceiptHandle",
            //         meta: {requireAuth: false, title: "处理", permission_id: "1341"},
            //         component(resolve) {
            //             require([`@/page/issueReceipt/handle.vue`], resolve)
            //         },
            //     }
            // ]
        },
        //设备点检大屏
        {
            path: "/patrolInspection",
            name: "patrolInspection",
            meta: {
                requireAuth: false,
                title: "设备点检大屏",
                permission_id: "1341",
            },
            component(resolve) {
                require([`@/page/patrolInspection/index.vue`], resolve)
            },
        },
        //加工码扫码
        {
            path: "/issuePrint",
            name: "issuePrint",
            meta: {
                requireAuth: false,
                title: "加工码扫码",
                permission_id: "1341",
            },
            component(resolve) {
                require([`@/page/issuePrint/index.vue`], resolve)
            },
        },
        // 车间计划大屏
        {
            path: "/workshopPlan",
            name: "workshopPlan",
            meta: {
                requireAuth: false,
                title: "车间计划大屏",
                permission_id: "1342",
            },
            component(resolve) {
                require([`@/page/workshopPlan/index.vue`], resolve)
            },
        },
        // 产品选型
        {
            path: "/productSelection",
            name: "productSelection",
            meta: {
                requireAuth: false,
                title: "产品选型",
                permission_id: "1342",
            },
            component(resolve) {
                require([`@/page/productSelection/index.vue`], resolve)
            },
        },
        {
            path: '*', // 页面不存在的情况下会跳到404页面
            redirect: '/error',
            name: 'notFound',
            hidden: true
        }

    ]
})